import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ToggleSwitch } from '@/components/ui/toggle-switch'
import { useDesignVersionToggle } from '@/hooks'

import OrganisationSKUModal from '../OrganisationSKU/OrganisationSKUModal'
import withAccordionControl from '../../Accordion/withAccordionControl'
import { SERVICE_CATEGORIES } from '../../../helpers/constants'
import {
  fetchShopCollection,
  selectShopServices,
} from '../../../reducers/Organisation/organisationShopReducer'
import { fetchAllBookingTypesOnly } from '../../../reducers/Organisation/bookTypesReducer'

import { LEGACY_BASE_PATH } from './legacy-path'
import OrganisationServicesModal from './OrganisationServicesModal'
import OrganisationServicesItem from './OrganisationServicesItem'

const OrganisationServices = ({ accordionToggle, accordionOpened }) => {
  const { t } = useTranslation(['organisation'])
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { redirect, toggle: handleUIToggle } = useDesignVersionToggle({
    group: 'services',
    screen: 'Services',
    to: { path: '/dashboard/organisation/services' },
    version: 'legacy',
  })
  const services = useSelector(selectShopServices) || []
  const params = useParams()
  const location = useLocation()

  const [parentCategory, setParentCategory] = useState(location?.state?.parentCategory || '')

  useEffect(() => {
    dispatch(fetchShopCollection())
    dispatch(fetchAllBookingTypesOnly())
  }, [dispatch])

  const expandShopItem = (e, id, category) => {
    e.preventDefault()
    accordionToggle(id)
    setParentCategory(category)
  }

  if (redirect) return redirect

  return (
    <div className="ctp-shop-list">
      <div className="ctp-organisation__design-toggle">
        <ToggleSwitch
          falsyLabel={t('organisation:servicesPage.designToggle.old')}
          truthyLabel={t('organisation:servicesPage.designToggle.new')}
          checked={false}
          onChange={handleUIToggle}
        />
      </div>
      <div className="ctp-short-toolbar-wrapper">
        <button
          className="button button-primary auto-width"
          onClick={() => navigate(`${LEGACY_BASE_PATH}/new`)}
        >
          {t('organisation:shared.actions.addNew')}
        </button>
      </div>

      {SERVICE_CATEGORIES.map((category, index) => (
        <div key={index} className="ctp-shop-list__category">
          <h2>{category}</h2>
          {services
            .filter((service) => service.category === category)
            .map((service) => (
              <OrganisationServicesItem
                key={service.id}
                service={service}
                isExpanded={service.id === accordionOpened}
                onClick={(e) => expandShopItem(e, service.id, service.category)}
              />
            ))}
        </div>
      ))}

      <OrganisationServicesModal params={params} />

      <OrganisationSKUModal
        params={params}
        parentCategory={parentCategory}
        onModalClose={() => navigate(LEGACY_BASE_PATH)}
      />
    </div>
  )
}

export default withAccordionControl(OrganisationServices, 'multiple')
